var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerateKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12C1 5.92 5.92 1 12 1C15.72 1 19.01 2.85 21 5.67V3H23V9H17V7H19.48C17.87 4.59 15.12 3 12 3C7.03 3 3 7.03 3 12H1Z",
    fill: "#1976D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21H1V15H7V17H4.52C6.13 19.41 8.88 21 12 21C16.97 21 21 16.97 21 12H23C23 18.08 18.08 23 12 23C8.28 23 4.99 21.15 3 18.33V21Z",
    fill: "#1976D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2492 11.3636L17.1854 15.2998L17.2043 17.1666L13.4142 17.1854V15.2998H11.5286V13.4142L11.3636 13.2492C9.87868 13.961 8.04491 13.7018 6.81455 12.4714C5.2542 10.9111 5.2542 8.3749 6.81455 6.81455C8.3749 5.2542 10.9111 5.2542 12.4714 6.81455C13.7018 8.04491 13.961 9.87868 13.2492 11.3636ZM8.22876 8.22876C7.45094 9.00658 7.45094 10.2794 8.22876 11.0572C9.00658 11.835 10.2794 11.835 11.0572 11.0572C11.835 10.2794 11.835 9.00658 11.0572 8.22876C10.2794 7.45094 9.00658 7.45094 8.22876 8.22876Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateKey);
export default __webpack_public_path__ + "static/media/generateKey.0943f9f6f4ed1d3d9b2b01f28ba10385.svg";
export { ForwardRef as ReactComponent };